import { ResourcePostData } from './types';
import { craftingBusinessDeck } from './posts/crafting-business-deck';
import { craftingPerfectPitchDeck } from './posts/crafting-perfect-pitch-deck';
import { pitchDeckTemplateSlideBySlide } from './posts/pitch-deck-template-slide-by-slide';
import { fivePitchDeckMistakes } from './posts/5-pitch-deck-mistakes-kill-fundraising';
import { realGuideToAIPresentationBuilders } from './posts/real-guide-to-ai-presentation-builders';
import { aiForPPTGuide } from './posts/ai-for-ppt-guide';
import { whyProfessionalNeedsAIBuilder } from './posts/why-professional-needs-ai-builder';
import { deckwaleVsGensparkAi } from './posts/deckwale-vs-genspark-ai';
import { deckwaleVsGamma } from './posts/deckwale-vs-gamma';
import { deckwaleVsSlidebean } from './posts/deckwale-vs-slidebean';
import { deckwaleVsBeautifulAi } from './posts/deckwale-vs-beautiful-ai';
import { deckwaleVsChatGPT } from './posts/deckwale-vs-chatgpt';
import { professionalPresenterPlaybook } from './posts/professional-presenter-playbook-2026';

export * from './types';

export const resourcesData: ResourcePostData[] = [
    professionalPresenterPlaybook,
    whyProfessionalNeedsAIBuilder,
    aiForPPTGuide,
    craftingBusinessDeck,
    craftingPerfectPitchDeck,
    pitchDeckTemplateSlideBySlide,
    fivePitchDeckMistakes,
    realGuideToAIPresentationBuilders,
    deckwaleVsGensparkAi,
    deckwaleVsGamma,
    deckwaleVsSlidebean,
    deckwaleVsBeautifulAi,
    deckwaleVsChatGPT
];

export const getPostById = (id: string) => resourcesData.find(post => post.id === id);
